import { PageContainer } from "../components/PageContainer";
import { TeacherSignupForm } from "../components/SignupForms/TeacherSignupForm";

export const TeacherSignup = () => {
  return (
    <PageContainer>
      <TeacherSignupForm />
    </PageContainer>
  );
};
